import EventEmitter from 'events';

import { initializeComponents } from '../../../../../src/js/init';;
import '../../../../../src/js/util/what-input';

/**
 * ----------------------------------------------------------------------------------
 * --- Styles -----------------------------------------------------------------------
 * ----------------------------------------------------------------------------------
 */
import '../scss/index.scss';

 /**
   * ----------------------------------------------------------------------------------
   * --- Components -------------------------------------------------------------------
   * ----------------------------------------------------------------------------------
   */
import components from './components';

// import DialogManager from '../../../basis-kit/src/components/dialog/DialogManager';
// import SliderManager from '../../../basis-kit/src/components/slider/js/SliderManager';

const eventBus = (new EventEmitter()).setMaxListeners(100);
// new DialogManager(eventBus);
// new SliderManager(eventBus);

window.app = {
  eventBus
};

initializeComponents(components, eventBus);
